module.exports = __webpack_public_path__ + "media/images/FFFalpha50-a986eff850c94386d99900fd69986237.png";